import { ChangeDetectionStrategy, Component, Input, OnInit } from '@angular/core';

import { BetType } from '@bpos/common';
import { SitecoreMyBetsConfig } from '@frontend/sports/common/client-config-data-access';

import { MyBetsRaceBetType } from '../../../my-bets-base/models/my-bets-response';
import { MyBetsBet } from '../../../my-bets-base/models/my-bets-viewmodels';

@Component({
    changeDetection: ChangeDetectionStrategy.OnPush,
    selector: 'ms-my-bets-betslip-option-name',
    styleUrl: 'my-bets-betslip-option-name.component.scss',
    templateUrl: 'my-bets-betslip-option-name.component.html',
    standalone: false,
})
export class MyBetsBetslipOptionNameComponent implements OnInit {
    @Input() bet: MyBetsBet;

    participantNames?: string[];

    constructor(public sitecoreMyBets: SitecoreMyBetsConfig) {}

    get isBasicOptionName(): boolean {
        return !(
            (this.bet.participantInfo &&
                (this.bet.participantInfo.betType === MyBetsRaceBetType.Forecast ||
                    this.bet.participantInfo.betType === MyBetsRaceBetType.Tricast)) ||
            (this.bet.optionMarketInfo &&
                (this.bet.optionMarketInfo?.betType === BetType.Forecast || this.bet.optionMarketInfo?.betType === BetType.Tricast))
        );
    }

    ngOnInit() {
        if (!this.isBasicOptionName) {
            this.participantNames = this.bet.participantInfo ? this.bet.participantInfo.participants : this.bet.optionNames;
        }

        if (this.bet.optionMarketInfo?.betType === BetType.CombinationForecast || this.bet.optionMarketInfo?.betType === BetType.CombinationTricast) {
            this.bet.optionName = this.bet.optionNames.join(',');
        }
    }
}
